import { Field, FieldArray, useFormikContext } from "formik";
import _ from "lodash";
import { X } from "react-feather";
import { Input } from "../../Form/Input/Input";
import { Button } from "../../UI/Button/Button";
import styles from "./Bullets.module.scss";

export const Bullets = ({ text = "Add details", slug, type = "ul" }) => {
  const { values } = useFormikContext();
  const List = type === "ul" ? "ul" : "ol";

  return (
    <FieldArray name={slug}>
      {(arrayHelpers) => (
        <div className={styles.root}>
          {_.get(values, slug) && _.get(values, slug).length > 0 ? (
            <>
              <List>
                {_.get(values, slug).map((bullet, index) => (
                  <li key={index}>
                    <Field
                      name={`${slug}.${index}`}
                      className={styles.listItemInput}
                      as={Input}
                    />
                    <X
                      size={20}
                      className={styles.removeListItemButton}
                      onClick={() => arrayHelpers.remove(index)}
                    />
                  </li>
                ))}
              </List>
              <Button
                className={styles.addListItemButton}
                onClick={() => arrayHelpers.push("")}
              >
                Add item
              </Button>
            </>
          ) : (
            <Button
              className={styles.addListButton}
              onClick={() => arrayHelpers.push("")}
            >
              {text}
            </Button>
          )}
        </div>
      )}
    </FieldArray>
  );
};
